import { reactive } from 'vue';

/**
 * This function is for the expansion panels settings on content detail page
 * @returns {object} settings - Content detail page expansion panels settings
 * @example {
 *   const settings = useMediaExpansionPanels();
 *
 *   return {
 *     openedItems: [0, 1, 2],
 *     flat: true,
 *     accordion: true,
 *     multiple: true,
 *     readonly: true,
 *   }
 * }
 */
const useMediaExpansionPanels = () => reactive({
  openedItems: [],
  flat: true,
  accordion: true,
  multiple: true,
  readonly: false,
});

export default useMediaExpansionPanels;
